module.exports = __webpack_public_path__ + "static/media/welcome_banner_small.fa0e3377.jpeg";